import React from 'react';

// Validação de CPF
export const validateCPF = (cpf) => {
  cpf = cpf.replace(/[^\d]/g, '');
  
  if (cpf.length !== 11) return false;
  
  // Verifica se todos os dígitos são iguais
  if (/^(\d)\1+$/.test(cpf)) return false;
  
  // Validação dos dígitos verificadores
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cpf.charAt(i)) * (10 - i);
  }
  let remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) remainder = 0;
  if (remainder !== parseInt(cpf.charAt(9))) return false;
  
  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cpf.charAt(i)) * (11 - i);
  }
  remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) remainder = 0;
  if (remainder !== parseInt(cpf.charAt(10))) return false;
  
  return true;
};

// Função para aplicar máscara de CPF
const formatCPF = (value) => {
  const digits = value.replace(/\D/g, '').slice(0, 11);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}.${digits.slice(3)}`;
  if (digits.length <= 9) return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;
  return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}`;
};

// Função para aplicar máscara de telefone
const formatPhone = (value) => {
  const digits = value.replace(/\D/g, '').slice(0, 11);
  if (digits.length <= 2) return digits.length > 0 ? `(${digits}` : '';
  if (digits.length <= 7) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
};

// Componente de Input CPF
export const CpfInput = ({ value, onChange, className, error, ...props }) => {
  const handleChange = (e) => {
    const formatted = formatCPF(e.target.value);
    onChange(formatted);
  };

  return (
    <div>
      <input
        type="text"
        value={value}
        onChange={handleChange}
        className={`${className} ${error ? 'border-red-500' : ''}`}
        placeholder="000.000.000-00"
        maxLength={14}
        {...props}
      />
      {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
    </div>
  );
};

// Componente de Input Telefone
export const PhoneInput = ({ value, onChange, className, error, ...props }) => {
  const handleChange = (e) => {
    const formatted = formatPhone(e.target.value);
    onChange(formatted);
  };

  return (
    <div>
      <input
        type="text"
        value={value}
        onChange={handleChange}
        className={`${className} ${error ? 'border-red-500' : ''}`}
        placeholder="(11) 99999-9999"
        maxLength={15}
        {...props}
      />
      {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
    </div>
  );
};

// Validação de telefone
export const validatePhone = (phone) => {
  const cleanPhone = phone.replace(/[^\d]/g, '');
  return cleanPhone.length === 11;
};

export default { CpfInput, PhoneInput, validateCPF, validatePhone };
